import { getId } from '@/assets/js/utils';

//
// state
const state = {
  /**
   * Annotation Hover Ids
   * An array of ids of all annotations belonging to the thread of a hovered-over annotation
   */
  annotationHoverIds: {},

  /**
   * Annotation Focus Ids
   * An array of ids of all annotations belonging to the thread of a focused (on the inner text-box) annotation
   */
  annotationFocusIds: {},
};

//
// getters
const getters = {
  getRefAnnotationsIds: (state, getters) => annotation => {
    let refAnnotations = state.counterpointData.counterpointsFlat?.filter(
      ann => getId(ann.refAnnotation) === getId(annotation)
    );
    let refAnnotationsIds = refAnnotations?.reduce(
      (idsArr, refAnnotation) => [...idsArr, ...getters.getRefAnnotationsIds(refAnnotation)],
      []
    );
    return refAnnotations.length ? [getId(annotation), ...refAnnotationsIds] : [getId(annotation)];
  },
  getRefByAnnotationsIds: (state, getters) => annotation => {
    let refAnnotations = state.counterpointData.counterpointsFlat?.filter(
      ann => getId(ann) === getId(annotation.refAnnotation)
    );
    let refAnnotationsIds = refAnnotations?.reduce(
      (idsArr, refAnnotation) => [...idsArr, ...getters.getRefByAnnotationsIds(refAnnotation)],
      []
    );
    return refAnnotations.length ? [getId(annotation), ...refAnnotationsIds] : [getId(annotation)];
  },
};

//
// mutations
const mutations = {
  /** Hover Ids functions */
  setAnnotationHoverIds: (state, value) => {
    //
    // set annotations ids to true on annotationHoverIds map object
    value.forEach(annId => {
      state.annotationHoverIds[annId] = true;
    });
  },

  clearAnnotationHoverIds: state => {
    state.annotationHoverIds = {};
  },

  /** Focus Ids functions */
  setAnnotationFocusIds: (state, value) => {
    //
    // set annotations ids to true on annotationHoverIds map object
    value.forEach(annId => {
      state.annotationFocusIds[annId] = true;
    });
  },

  clearAnnotationFocusIds: state => {
    state.annotationFocusIds = {};
  },
};

//
// actions
const actions = {
  /** Hover Ids functions */
  annotationHoverIn: ({ getters, commit }, annotation) => {
    //
    // add IDs for citationd annotaions
    let annArray = [
      ...getters.getRefByAnnotationsIds(annotation),
      ...getters.getRefAnnotationsIds(annotation),
    ];
    //
    // set annotation IDs
    commit('setAnnotationHoverIds', annArray);
  },

  annotationHoverOut({ commit }) {
    commit('clearAnnotationHoverIds');
  },

  /** Focus Ids functions */
  annotationFocusIn: ({ getters, commit }, annotation) => {
    //
    // add IDs for citationd annotaions
    let annArray = [
      ...getters.getRefByAnnotationsIds(annotation),
      ...getters.getRefAnnotationsIds(annotation),
    ];
    //
    // set annotation IDs
    commit('setAnnotationFocusIds', annArray);
  },

  annotationFocusOut({ commit }) {
    commit('clearAnnotationFocusIds');
  },
};

//
// exports
export default {
  // namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
